const BASE_URL: string = process.env.REACT_APP_API_KEY || '';

//merchant user
export const FIND_MANY_MERCHANT_USER = BASE_URL + '/merchant/merchant-user/find-many';
export const FIND_MANY_MERCHANT_STORE = BASE_URL + '/merchant/merchant-store/find-many';
export const CREATE_MERCHANT_USER = BASE_URL + '/merchant/merchant-user/create';
export const UPDATE_MERCHANT_USER = BASE_URL + '/merchant/merchant-user/update?Id=';
export const DELETE_MERCHANT_USER = BASE_URL + '/merchant/merchant-user/delete?Id=';

export const CHANGE_PASSWORD = BASE_URL + '/merchant/merchant-user/change-password'

//Profile merchant user
export const UPDATE_MERCHANT_USER_PROFILE = BASE_URL + '/profile/merchantProfile/Update?Id=';
export const DELETE_MERCHANT_USER_PROFILE = BASE_URL + '/profile/merchantProfile/Delete?Id=';

//role and permission
export const FIND_ROLE_AND_PERMISSION = BASE_URL + '/rolePermission/role/findMany';

//image merchant user
export const IMAGE_URL_MERCHANT_USER = BASE_URL+'/profile/api/';